//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var e = (e) => e, t = (() => {
	let t = e;
	return {
		configure(e) {
			t = e;
		},
		generate(e) {
			return t(e);
		},
		reset() {
			t = e;
		}
	};
})();
//#endregion
export { t as default };

//# sourceMappingURL=index52.js.map